var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.poseUrl)?_c('div',{staticClass:"pose-icon",class:_vm.practiceStyle},[_c('img',{attrs:{"src":'//www.pocketyoga.com/assets/images/thumbnails146/' + _vm.poseUrl,"alt":_vm.poseAlt}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }